export const IDENTITY_UNIQUENESS_POLICY = Object.freeze({
  policyId: "exiled-systems-verified-identity-uniqueness",
  version: "draft-2026-07-21.1",
  status: "required-before-registration",
  effective: false,
  serverAuthorityRequired: true,
  failClosed: true,
  verifiedReuse: "never",
  publicAvailabilityLookup: false,
  privacyDisclosureRequired: true,
  pendingReservation: Object.freeze({
    required: true,
    suggestedTtlSeconds: 1800,
    releaseRule: "expired-unverified-only",
  }),
  genericPrivateConflictMessage:
    "Those account details cannot be used. Sign in or recover your account if they may be yours.",
  requiredActivationGates: Object.freeze([
    "identityUniquenessEnforced",
    "pendingIdentityReservationsEnabled",
    "avatarOwnershipVerificationEnabled",
  ]),
  identifiers: Object.freeze([
    Object.freeze({
      fieldId: "handle",
      kind: "username",
      normalization: "trim-ascii-lower",
      exposure: "public",
      verifiedReuse: "never",
    }),
    Object.freeze({
      fieldId: "email",
      kind: "email",
      normalization: "trim-lowercase",
      exposure: "private",
      verifiedReuse: "never",
    }),
    Object.freeze({
      fieldId: "avatarKey",
      kind: "second-life-avatar-key",
      normalization: "canonical-uuid-lower",
      exposure: "private",
      verifiedReuse: "never",
      ownershipVerificationRequired: true,
    }),
  ]),
});

export function isIdentityUniquenessPolicyReady(
  registrationState,
  policy = IDENTITY_UNIQUENESS_POLICY,
) {
  return Boolean(
    policy?.effective === true
    && policy?.serverAuthorityRequired === true
    && policy?.failClosed === true
    && policy?.requiredActivationGates?.every((key) => registrationState?.[key] === true),
  );
}
